<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :optType="pageType"
        :disabledPrint="disabledPrint"
        :hxFtyNoticeInCode="hxFtyNoticeInCode"
      />
      <div class="d-flex justify-content-end mt-2" v-if="!disabled">
        <el-button type="primary" size="small" @click="$refs.editForm.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-hxBiz-hxFtyInvInNotice-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return (
        this.pageType === 'detail' ||
        this.pageType === 'send' ||
        this.pageType === 'confirm'
      )
    },
    disabledPrint() {
      const hxFtyNoticeInStatus = this.params.hxFtyNoticeInStatus
      return (
        hxFtyNoticeInStatus !== 'S' &&
        hxFtyNoticeInStatus !== 'F' &&
        hxFtyNoticeInStatus !== 'Y'
      )
    },
    hxFtyNoticeInCode() {
      return this.params.hxFtyNoticeInCode
    },
  },
}
</script>
